import React, { useContext, useEffect } from 'react'
import styles from '../styles.module.css'
import Table from '../../../components/Table'
import { getClassbookFitnessIndicators } from '../../../actions/fitnessIndicators'
import { useDispatch, useSelector } from 'react-redux'
import { ClassbookContext } from '../../../utils/context'

export default function ClassbookFitnessIndicators() {

    const dispatch = useDispatch()
    const { formData } = useContext(ClassbookContext)

    const { classbookFitnessIndicatorsList } = useSelector(state => state.fitnessIndicators)

    useEffect(() => {
        const { studyPeriod: trmid, lesson: cid, class: gid } = formData
        dispatch(getClassbookFitnessIndicators(trmid, cid, gid))
    }, [formData])



    const renderLi = (data) => {
        const { iid, iname } = data
        return (
            <tr >
                <td>{iname}</td>
                {/* <td><i className={styles.trash} onClick={() => setConfirmation({ id: iid, name: iname })}><BiTrash /></i></td> */}
            </tr>
        )
    }
    return (
        <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>

            <h1>Показатели физической подготовки</h1>

            <Table className={styles.tableDis}>
                <thead>
                    <tr>
                        <th>Ученица</th>
                        <th>Показатель</th>
                        <th>Значение</th>
                        <th>Дата</th>
                    </tr>
                </thead>
                <tbody>
                    {classbookFitnessIndicatorsList?.length ?
                        classbookFitnessIndicatorsList?.map(renderLi) :
                        <tr>
                            <td colSpan={4}>Нет данных</td>
                        </tr>
                    }
                </tbody>
            </Table>
        </div>

    )
}